import { ThemeType } from 'carbon-components-angular';

export const LAYOUT_THEME: ThemeType = 'g10';
export const DRAWER_THEME: ThemeType = 'g100';
